import React, { useEffect, useRef, useState } from 'react'
import classes from './plansfaq.module.css'
import { ReactComponent as DownIcon } from '../../assets/images/down.svg'

const PlansFaq = ({ header, content }) => {
    const contentDiv = useRef()
    const [active, toggleActive] = useState(false)
    const [contentDivHeight, setHeight] = useState(0)
    useEffect(() => {
        if (contentDiv.current) {
            setHeight(contentDiv.current.scrollHeight)
        }
    }, [contentDiv.current])

    return (
        <button className={classes.faq} onClick={() => toggleActive(!active)}>
            <h1 className={classes.faqHeader}>
                <span className={classes.faqHeaderText}>{header}</span>
                <DownIcon
                    className={[
                        classes.faqHeaderIcon,
                        active && classes.faqHeaderIconRotate,
                    ].join(' ')}
                />
            </h1>
            <p
                className={classes.faqContent}
                ref={contentDiv}
                style={{
                    height: `${active ? contentDivHeight : 0}px`,
                    marginTop: `${active ? 10 : 0}px`,
                }}
            >
                {content}
            </p>
        </button>
    )
}

export default PlansFaq
